import { memo, useContext, useEffect, useState } from "react";
import moment from "moment";
import { SocketContext } from "../../socket/socket";
import syncImg from "../../assets/images/check_icn.svg";
import inProgressImg from "../../assets/images/syncwith_progress.svg";
import notsync_icn from "../../assets/images/notsync_icn.svg";
import { getTimeAgoString } from "../../utils/utils";

const DocumentStatus = ({ data }) => {
  const socketContext = useContext(SocketContext);
  const [trainingStatus, setTrainingStatus] = useState(data?.row?.original?.training_status ?? null);
  const [updatedStatusDocument, setUpdatedStatusDocument] = useState(null);
  
  useEffect(() => {
    const documentProcessedEvent = (res) => {
      if (data?.row?.original?.uuid === res.documentUUID) {
        setTrainingStatus(() => res.training_status ?? null);
        setUpdatedStatusDocument({
          ...updatedStatusDocument,
          ...res,
        });
      }
    };

    const documentSuccessEvent = (res) => {
      if (data?.row?.original?.uuid === res.documentUUID) {
        setTrainingStatus(null);
        setUpdatedStatusDocument({
          ...updatedStatusDocument,
          ...res,
        });
      }
    }

    if (socketContext?.socket) {
      socketContext?.socket.off("documentProcessed", documentProcessedEvent);
      socketContext.socket.on("documentProcessed", documentProcessedEvent);

      socketContext.socket.off("success", documentSuccessEvent);
      socketContext.socket.on("success", documentSuccessEvent);
    }
    return () => {
      socketContext?.socket?.off("documentProcessed", documentProcessedEvent);
      socketContext.socket?.off("success", documentSuccessEvent);
    }
  }, [socketContext, trainingStatus, updatedStatusDocument]);
  
  let isSynced = data?.row?.original?.is_synced === 1;
  let isUnSynced = data?.row?.original?.is_synced === 0;
  let isSyncing = data?.row?.original?.is_synced === 2;
  
  if (updatedStatusDocument && updatedStatusDocument.documentUUID === data?.row?.original?.uuid) {
    isSynced = updatedStatusDocument.is_synced === 1;
    isUnSynced = updatedStatusDocument.is_synced === 0;
    isSyncing = updatedStatusDocument.is_synced === 2;
  }
  
  let syncedAt = isSynced ? (updatedStatusDocument?.synced_at ?? data?.row?.original?.synced_at) : null;

  return (
    <>
      {/*
        SYNCED: 1,
        UNSYNCED: 0,
        SYNC_IN_PROGRESS: 2 
      */}
      {isSynced && (
        <>
          <span className="status status-text sync">
            <img className="syncicn-img" src={syncImg} alt="" /> Trained
          </span>
          <p class="doc-date mt-2 doc-date-text">
            {moment(syncedAt)
                .utc()
                .local()
                .format("MMM DD, YYYY hh:mm A")}

            <span className="d-block">
              {getTimeAgoString(syncedAt)}
            </span>
          </p>
        </>
      )}

      {isUnSynced && (
        <span className="status status-text notsync">
          <img className="syncicn-img" src={notsync_icn} alt="" /> Not
          Trained
        </span>
      )}

      {isSyncing && (
        <>
          <span className="status status-text inporgesssync">
            <img className="syncicn-img" src={inProgressImg} alt="" />{" "}
            Training
          </span>
          {Boolean(trainingStatus) && (
            <p className="mt-2 doc-date-text">{trainingStatus}</p>
          )}
        </>
      )}
    </>
  );
}

export default memo(DocumentStatus);
